<p>operation-cadrage-indicators works!</p>
